import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_3 = {
  key: 1,
  class: "pl-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_edit = _resolveComponent("v-btn-edit")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pb-0 mb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2 fill-height",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            "mt-2": "",
            class: "align-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-start align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'partitionstags-table' })))
                  }),
                  _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "ml-2" }, "Partition générique", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex align-center justify-end"
              }, {
                default: _withCtx(() => [
                  (_ctx.currentPartitionTag.id !== 'WithoutId')
                    ? (_openBlock(), _createBlock(_component_v_btn_edit, {
                        key: 0,
                        disabled: _ctx.isDisabled,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upsertPartitionTag()))
                      }, null, 8, ["disabled"]))
                    : (_openBlock(), _createBlock(_component_v_btn_add, {
                        key: 1,
                        disabled: _ctx.isDisabled,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.upsertPartitionTag()))
                      }, null, 8, ["disabled"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, { class: "default_card_admin large" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            color: "primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex align-center pt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.currentPartitionTagName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPartitionTagName) = $event)),
                    label: "Nom de la partition",
                    outlined: "",
                    "hide-details": "",
                    "data-cy": "PartitionTag-nomPartition",
                    density: "compact"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-start align-center pb-2"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createElementVNode("h2", null, "Étiquettes de votre partition", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPartitionTag.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-group-item item px-2 py-1 mr-2 d-flex",
                      style: {"width":"fit-content !important","float":"left"},
                      key: tag.id,
                      onClick: _withModifiers(($event: any) => (_ctx.editTag(tag)), ["stop"])
                    }, [
                      (_ctx.currentPartitionTag.type === 'Building')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_v_icon, {
                              dense: "",
                              size: "x-small"
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode("$fa-building")
                              ])),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(tag.name), 1),
                      (!_ctx.disabledDeleteTag(_ctx.currentPartitionTag))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (tag.id)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (_ctx.deleteTag(tag.id)), ["stop"]),
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode("$oss-trash")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_1))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "11",
                class: "d-flex pt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.newTagName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newTagName) = $event)),
                    label: "Nom du nouveau tag",
                    color: "primary",
                    outlined: "",
                    "hide-details": "",
                    "data-cy": "PartitionTag-newTag",
                    density: "compact"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "1",
                class: "d-flex justify-center align-center pt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    size: "small",
                    dark: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createTag(_ctx.currentPartitionTag))),
                    icon: "$add"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, { class: "default_card_admin" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-start align-center pb-2"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("h2", null, "Comptes racines de votre partition", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_combobox_filled, {
                    modelValue: _ctx.currentPartitionTag.rules.rootAccountableAccounts,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentPartitionTag.rules.rootAccountableAccounts) = $event)),
                    label: "Un de ces comptes racines",
                    multiple: "",
                    outlined: "",
                    class: "mt-2",
                    dense: "",
                    chips: "",
                    "deletable-chips": "",
                    "item-disabled": "",
                    rules: [_ctx.rules.onlyNumbers],
                    "data-cy": "PartitionTag-comptesRacines"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ScopeManager, {
        modelValue: _ctx.scopeSync,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scopeSync) = $event)),
        id: _ctx.scopeId,
        "onUpdate:id": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scopeId) = $event)),
        name: _ctx.scopeName,
        "onUpdate:name": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scopeName) = $event)),
        readonly: _ctx.readonly,
        "data-cy": "PartitionTag-perimettrePartition"
      }, null, 8, ["modelValue", "id", "name", "readonly"])
    ]),
    _: 1
  }))
}